import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { ReactComponent as CardEditIcon } from "../../../../myfin_v2/assets/icons/editCard.svg";
import { ReactComponent as CloseSideModel } from "../../../../myfin_v2/assets/icons/closeSideModel.svg";
import { ReactComponent as QuestionMark } from "../../../../myfin_v2/assets/icons/questionECL.svg";
import { ReactComponent as ActiveRadioBtn }  from '../../../../myfin_v2/assets/icons/activeRadioBtn.svg'
import { ReactComponent as InactiveRadioBtn }  from '../../../../myfin_v2/assets/icons/inactiveRadioBtn.svg'
import { ReactComponent as CreateNewScenario }  from '../../../../myfin_v2/assets/icons/createNewScenario.svg'
import demoUserImg from "../../../../assets/Image/CreatedUserImg.jpg"

import CompanyEditSideMenu from "../CompanyEditSideMenu"

import AcntPolcyCss from "../../../css/accountingPolicy.module.css"
import commoncss from "../../../css/common.module.css";
import sidemenucss from "../../../css/sidemenu.module.css"
import Breadcrumb from "../../../components/Breadcrumb";

import HeaderWhenSecondSideBarActive from "../../../elements/HeaderWhenSecondSideBarActive"
import Select from 'react-select';

import { getAllLoanECLScenario, getAllLoanEIRScenario, addLoanEIRScenario, updateLoanEIRScenario, deleteLoanEIRScenario, getAllLoanIRACScenario, addLoanIRACScenario, updateLoanIRACScenario, deleteLoanIRACScenario } from "../../../../Bookclosure/Services/ApiHandler"

import Modal from "../../../elements/Modal";
import modalcss from "../../../css/modal.module.css";
import { Button } from "../../../elements/Button";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import buttoncss from "../../../css/button.module.css";
const LoanPolicy = () => {
    const { companyId } = useParams();
    const [companyID, setCompanyID] = useState(companyId);  // company ID
    const [createOrUpdate, setCreateOrUpdate] = useState('C');  // state for create or update
    
    // EIR Input
    const [EirScenarioName, setEirScenarioName] = useState(); 
    const [EirCalculateType, setEirCalculateType] = useState('straightLine'); 
    const [EirCompute, setEirCompute] = useState('grossOfECL');

    const [companyName, setcompanyName] = useState('');  // company name
    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: companyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Accounting policy",
            link: `/myfinV2/accounting-policy/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        }, 
        {
            label: "Loans",
            link: `/myfinV2/loan-policy/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        }, 
    ];

    const [createNewScen, setcreateNewScen] = useState('')

    const [activeTab, setActiveTab] = useState('EIR'); // tabs state

    const routerHistory = useHistory();

    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    const [createTab, setCreateTab] = useState("I") // A active show tab I inactive hide tab
    const [sideTabType, setsideTabType] = useState(); // ECL or EIR or IRAC 

    const [IRACName, setIRACName] = useState()
    const [IRACStandard, setIRACStandard] = useState()
    const [IRACSubStandard, setIRACIRACSubStandard] = useState()
    const [IRACSDoubtfulAssets1, setIRACSDoubtfulAssets1] = useState()
    const [IRACSDoubtfulAssets2, setIRACSDoubtfulAssets2] = useState()

    const makeInputsEmpty = (EirOrIrac) => {

        if(EirOrIrac === 'EIR'){
            setEirScenarioName('')
            setEirCalculateType('straightLine')
            setEirCompute('grossOfECL')
        }

        if(EirOrIrac === 'IRAC'){
            setIRACName('')
            setIRACStandard('')
            setIRACIRACSubStandard('')
            setIRACSDoubtfulAssets1('')
            setIRACSDoubtfulAssets2('')
        }
    }

    return (
        <div className={`${AcntPolcyCss.subContainer}`}>
            <CompanyEditSideMenu 
                companyID={companyID}
                activeTab={'Accounting Policies'}
                companyDataCheck={true}
                setcompanyName={setcompanyName}
            />

            <div className={AcntPolcyCss.subContainer__}>
               
                <div className={AcntPolcyCss.headerWrapper}>
                    <Breadcrumb
                        addCls="bgTransprent"
                        items={breadcrumbItems}
                        headerActions={<></>}
                        p0={true}
                    />
                    <div>
                        <button type="button" className={`${AcntPolcyCss.createStagingBtn} ${ createTab === 'A' ? AcntPolcyCss.disableCreateBtn : ''}`}
                            disabled={createTab === 'A'}
                            onClick={() => {
                                if (activeTab === 'ECL') {
                                    handleClick(`/myfinV2/loans/create-ecl-scenario/${companyID}`);
                                } else if (activeTab === 'EIR') {
                                    // setcreateNewScen('EIR');
                                    setCreateTab('A');
                                    setsideTabType('EIR'); 
                                    setCreateOrUpdate('C');
                                    makeInputsEmpty('EIR') // clears all inputs fields
                                } else if (activeTab === 'IRAC') {
                                    // setcreateNewScen('IRAC');
                                    setCreateTab('A');
                                    setsideTabType('IRAC'); 
                                    setCreateOrUpdate('C');
                                    makeInputsEmpty('IRAC') // clears all inputs fields
                                }
                            }}
                        >Create New Scenario</button>
                    </div>
                </div>
                <MulitTabsContainer 
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    companyID={companyID} 
                    createOrUpdate={createOrUpdate}   // Pass createOrUpdate
                    setCreateOrUpdate={setCreateOrUpdate}
                    EirScenarioName={EirScenarioName} 
                    setEirScenarioName={setEirScenarioName}
                    EirCalculateType={EirCalculateType} 
                    setEirCalculateType={setEirCalculateType}
                    EirCompute={EirCompute} 
                    setEirCompute={setEirCompute}
                    createNewScen={createNewScen} 
                    setcreateNewScen={setcreateNewScen}

                    createTab={createTab}
                    setCreateTab={setCreateTab}

                    sideTabType={sideTabType}
                    setsideTabType={setsideTabType}

                    IRACName={IRACName}
                    setIRACName={setIRACName}
                    IRACStandard={IRACStandard}
                    setIRACStandard={setIRACStandard}
                    IRACSubStandard={IRACSubStandard}
                    setIRACIRACSubStandard={setIRACIRACSubStandard}
                    IRACSDoubtfulAssets1={IRACSDoubtfulAssets1}
                    setIRACSDoubtfulAssets1={setIRACSDoubtfulAssets1}
                    IRACSDoubtfulAssets2={IRACSDoubtfulAssets2}
                    setIRACSDoubtfulAssets2={setIRACSDoubtfulAssets2}
                    makeInputsEmpty={makeInputsEmpty}
                />
            </div>
            
        </div>
    );
};

export default LoanPolicy;


const MulitTabsContainer = ({
    createNewScen, 
    setcreateNewScen,
    companyID,
    createOrUpdate,  // Receive createOrUpdate from the parent
    setCreateOrUpdate,

    EirScenarioName,
    setEirScenarioName,

    EirCalculateType,
    setEirCalculateType,

    EirCompute, 
    setEirCompute,
    activeTab, 
    setActiveTab,

    createTab, 
    setCreateTab,

    sideTabType, 
    setsideTabType,

    IRACName, 
    setIRACName,
    IRACStandard, 
    setIRACStandard,
    IRACSubStandard, 
    setIRACIRACSubStandard,
    IRACSDoubtfulAssets1, 
    setIRACSDoubtfulAssets1,
    IRACSDoubtfulAssets2, 
    setIRACSDoubtfulAssets2,

    makeInputsEmpty
    
    }) => {

    const [displayModal, setDisplayModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const handleClose = () => {
    setDisplayModal(false);
    setDeleteModal(false);
    };

    const routerHistory = useHistory();

    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    // ECL data List of items
    const [ECLLoansData , setECLLoansData] = useState([])

    // EIR data List of items
    const [EIRLoansData , setEIRLoansData] = useState([])
    const [upadteSelectedEir,setupadteSelectedEir] = useState()
    
    // IRAC data List of items
    const [IRACLoansData , setIRACLoansData] = useState([])
    const [upadteSelectedIRAC,setupadteSelectedIRAC] = useState()

    useEffect(() => {
            fetchECLData(companyID, setECLLoansData);
            fetchEIRData(companyID, setEIRLoansData);
            fetchIRACData(companyID, setIRACLoansData);
    }, [companyID]);

    // fetch ECL data List 
    const fetchECLData = async (companyID, setECLLoansData) => {
        try {
            const response = await getAllLoanECLScenario(companyID);
            const eclLoans = response.data.loanECLScenarioList;
            setECLLoansData(eclLoans);
        }
        catch (err) {
            console.error("Failed to fetch data", err);
        }
    };

    // fetch EIR data 
    const fetchEIRData = async (companyID, setEIRLoansData) => {
        try {
            const response = await getAllLoanEIRScenario(companyID);
            const eirLoans = response.data.loanEIRScenarioList;
            setEIRLoansData(eirLoans);
        }
        catch (err) {
            console.error("Failed to fetch data", err);
        }
    };
    
    // fetch IRAC data 
    const fetchIRACData = async (companyID, setIRACLoansData) => {
        try {
            const response = await getAllLoanIRACScenario(companyID);
            const iracLoans = response.data.loanIRACScenarioList;
            setIRACLoansData(iracLoans);
        }
        catch (err) {
            console.error("Failed to fetch data", err);
        }
    };

    

    const fillTheDataInToInputs = (EirOrIrac, id) => {

        if(EirOrIrac === 'EIR'){
            const eirData = EIRLoansData.find(item => item._id === id);
            setEirScenarioName(eirData.name)
            setEirCalculateType(eirData.calculationType)
            setEirCompute(eirData.computeEIR)
        }

        if(EirOrIrac === 'IRAC'){
            const iracData = IRACLoansData.find(item => item._id === id);
            
            setIRACName(iracData.name)
            setIRACStandard(iracData?.provisions?.[0]?.provisionPercentage)
            setIRACIRACSubStandard(iracData?.provisions?.[1]?.provisionPercentage)
            setIRACSDoubtfulAssets1(iracData?.provisions?.[2]?.provisionPercentage)
            setIRACSDoubtfulAssets2(iracData?.provisions?.[3]?.provisionPercentage)
            
        }
        
    }
    
    const sendDataToEirApi = (createOrUpdateType) => {
        
        if(createOrUpdateType === 'C'){

            let obj = {
                        "name": EirScenarioName,
                        "companyID": companyID,
                        "calculationType": EirCalculateType,
                        "computeEIR": EirCompute,
                    }

            addLoanEIRScenario(obj).then(() => {
                makeInputsEmpty('EIR'); // clear input feilds and make inputs empty
                toast.success("EIR created Successfully.");
                fetchEIRData(companyID , setEIRLoansData) // call the get api for all eir list
            });

        }
        else if(createOrUpdateType === 'U'){
            
            let obj = {
                        "name": EirScenarioName,
                        "companyID": companyID,
                        "calculationType": EirCalculateType,
                        "computeEIR": EirCompute,
                    }

            updateLoanEIRScenario(upadteSelectedEir,obj).then(() => {
                toast.success("EIR Updated Successfully.");
                fetchEIRData(companyID , setEIRLoansData) // call the get api for all eir list
            });
        }

        else if(createOrUpdateType === 'D'){
            deleteLoanEIRScenario(upadteSelectedEir).then(() => {
                toast.success("EIR Deleted Successfully.");
                setCreateTab('I')
                fetchEIRData(companyID , setEIRLoansData) // call the get api for all eir list
            });
        }
        
    }


    const sendDataToIRACApi = (createOrUpdateType) => {
        
        if(createOrUpdateType === 'C'){

            let obj = {
                        // Required: Name of the IRAC Scenario
                        "name": IRACName,

                        // Required: Company ID (MongoDB ObjectID format)
                        "companyID": companyID,

                        // Required: Provision configuration (array of provisions)
                        "provisions": [

                            {
                                "assetCategory": "Standard",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACStandard
                            },

                            {
                                "assetCategory": "Sub-standard",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSubStandard
                            },
                            {
                                "assetCategory": "Doubtful Assets 1",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSDoubtfulAssets1
                            },
                            {
                                "assetCategory": "Doubtful Assets 2",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSDoubtfulAssets2
                            }

                        ]
                    }

            addLoanIRACScenario(obj).then(() => {
                makeInputsEmpty('IRAC'); // clear input feilds and make inputs empty
                toast.success("IRAC created Successfully.");
                fetchIRACData(companyID , setIRACLoansData) // call the get api for all eir list
            });

        }
        else if(createOrUpdateType === 'U'){

            let obj = {
                        // Required: Name of the IRAC Scenario
                        "name": IRACName,

                        // Required: Company ID (MongoDB ObjectID format)
                        "companyID": companyID,

                        // Required: Provision configuration (array of provisions)
                        "provisions": [

                            {
                                "assetCategory": "Standard",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACStandard
                            },

                            {
                                "assetCategory": "Sub-standard",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSubStandard
                            },
                            {
                                "assetCategory": "Doubtful Assets 1",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSDoubtfulAssets1
                            },
                            {
                                "assetCategory": "Doubtful Assets 2",
                                "provisionCategory": "Up to 90 days",
                                "range": "4% to 8%",
                                "provisionPercentage": IRACSDoubtfulAssets2
                            }

                        ]
                    }

            updateLoanIRACScenario(upadteSelectedIRAC,obj).then(() => {
                toast.success("IRAC Updated Successfully.");
                fetchIRACData(companyID , setIRACLoansData) // call the get api for all eir list
            });

        }

        else if(createOrUpdateType === 'D'){
            deleteLoanIRACScenario(upadteSelectedIRAC).then(() => {
                toast.success("IRAC Deleted Successfully.");
                setCreateTab('I')
                fetchIRACData(companyID , setIRACLoansData) // call the get api for all eir list
            });
        }
        
    }

    useEffect(() => {
        if (!createNewScen) return;

            setCreateOrUpdate('C');

            if (createNewScen === 'ECL') {
                handleClick(`/myfinV2/loans/create-ecl-scenario/${companyID}`);
            } else if (createNewScen === 'EIR') {
                setCreateTab('A');
                setsideTabType('EIR');
                makeInputsEmpty('EIR');
            } else if (createNewScen === 'IRAC') {
                setCreateTab('A');
                setsideTabType('IRAC');
                makeInputsEmpty('IRAC');
            }
        },
    [createNewScen]);


    return(
        <div className={AcntPolcyCss.subMainContainer}>
            <div className={ createTab == 'A' ? AcntPolcyCss.tabContainerSideContainer :AcntPolcyCss.tabContainer}> 
                
                <div className={AcntPolcyCss.tabsContainer}>
                    <div onClick={ () => {setActiveTab('EIR'); setCreateTab('I')} } className={` ${AcntPolcyCss.tab} ${AcntPolcyCss.btn} ${ activeTab === 'EIR' ? AcntPolcyCss.btnActiveFirst : '' }`}>EIR</div>
                    <div onClick={ () => {setActiveTab('IRAC'); setCreateTab('I')} } className={` ${AcntPolcyCss.tab} ${AcntPolcyCss.btn} ${ activeTab === 'IRAC' ? AcntPolcyCss.btnActiveSecond : '' }`} >IRAC</div>
                    <div onClick={ () => {setActiveTab('ECL'); setCreateTab('I')} } className={` ${AcntPolcyCss.tab} ${AcntPolcyCss.btn} ${ activeTab === 'ECL' ? AcntPolcyCss.btnActiveSecond : '' }`}>ECL</div>
                </div>
                {/* ECL Cards Container */}
                {activeTab === 'ECL' && 
                    <div className={AcntPolcyCss.tabContantContainer}> 
                        {/* <div className={AcntPolcyCss.tabHeaderContainer}>
                            <button onClick={() => { 
                                setCreateOrUpdate('C'); 
                                handleClick(`/myfinV2/loans/create-ecl-scenario/${companyID}`);}} 
                                className={AcntPolcyCss.Btn}>Create New Scenario</button>
                        </div> */}
                        <div className={AcntPolcyCss.cardsContainer}>
                            <CreateNewScenario 
                                className={ createTab === 'A' ? AcntPolcyCss.createNewScenBtnSm : AcntPolcyCss.createNewScenBtn}  
                                onClick={() => { 
                                    setCreateOrUpdate('C'); 
                                    handleClick(`/myfinV2/loans/create-ecl-scenario/${companyID}`);
                                }} 
                            />
                            {ECLLoansData.map(ecl => (
                                <div key={1} className={ createTab == 'A' ? AcntPolcyCss.cardContainerSideContainer : AcntPolcyCss.cardContainer}  onClick={() => {handleClick(`/myfinV2/loans/update-ecl-scenario/${companyID}/${ecl._id}`)}}>
                                    <div className={AcntPolcyCss.cardHeader}>
                                        <div className={AcntPolcyCss.CardTitle}>
                                            {ecl.name}
                                        </div>
                                        <div>
                                            <CardEditIcon className={AcntPolcyCss.editIconSize} />
                                        </div>
                                    </div>
                                    <div className={AcntPolcyCss.cardDesc}>
                                        <img src={demoUserImg} alt="" style={{ height:'20px', width:'20px', borderRadius : '50%' }} />
                                        &nbsp;
                                        <span>
                                            Created by <span className={AcntPolcyCss.createdByName}>Adrienne Vossler</span>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                } 
                {/* EIR Cards Container */}
                {activeTab === 'EIR' && 
                    <div className={AcntPolcyCss.tabContantContainer}>
                        {/* <div className={AcntPolcyCss.tabHeaderContainer}>
                            <button onClick={() => { 
                                setCreateTab('A');
                                setsideTabType('EIR'); 
                                setCreateOrUpdate('C');
                                makeInputsEmpty('EIR') // clears all inputs fields
                                }} 
                                className={AcntPolcyCss.Btn}>Create New Scenario</button>
                        </div> */}
                        <div className={AcntPolcyCss.cardsContainer}>
                            <CreateNewScenario 
                                className={ createTab === 'A' ? AcntPolcyCss.createNewScenBtnSm : AcntPolcyCss.createNewScenBtn}  
                                onClick={() => { 
                                    setCreateTab('A');
                                    setsideTabType('EIR'); 
                                    setCreateOrUpdate('C');
                                    makeInputsEmpty('EIR') // clears all inputs fields
                                }} 
                            />
                            {EIRLoansData.map(eirObject => (
                                <div key={1} 
                                    className={ createTab === 'A' ? AcntPolcyCss.cardContainerSideContainer : AcntPolcyCss.cardContainer}  
                                    onClick={() => {
                                        setsideTabType('EIR'); 
                                        setupadteSelectedEir(eirObject._id);
                                        setCreateTab('A');
                                        fillTheDataInToInputs('EIR', eirObject._id); 
                                        setCreateOrUpdate('U');
                                    }}>
                                    <div className={AcntPolcyCss.cardHeader}>
                                        <div className={AcntPolcyCss.CardTitle}>
                                            {eirObject.name}
                                        </div>
                                        <div>
                                            <CardEditIcon className={AcntPolcyCss.editIconSize} />
                                        </div>
                                    </div>
                                    <div className={AcntPolcyCss.cardDesc}>
                                        <img src={demoUserImg} alt="" style={{ height:'20px', width:'20px', borderRadius : '50%' }} />
                                        &nbsp;
                                        <span>
                                            Created by <span className={AcntPolcyCss.createdByName}>Adrienne Vossler</span>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                } 
                {/* IRAC Cards Container */}
                {activeTab === 'IRAC' && 
                    <div className={AcntPolcyCss.tabContantContainer}>
                        {/* <div className={AcntPolcyCss.tabHeaderContainer}>
                            <button onClick={() => { 
                                setCreateTab('A');
                                setsideTabType('IRAC'); 
                                setCreateOrUpdate('C');
                                makeInputsEmpty('IRAC') // clears all inputs fields
                                }} 
                                className={AcntPolcyCss.Btn}>Create New Scenario</button>
                        </div> */}
                        <div className={AcntPolcyCss.cardsContainer}>
                            <CreateNewScenario 
                                className={ createTab === 'A' ? AcntPolcyCss.createNewScenBtnSm : AcntPolcyCss.createNewScenBtn}  
                                onClick={() => { 
                                    setCreateTab('A');
                                    setsideTabType('IRAC'); 
                                    setCreateOrUpdate('C');
                                    makeInputsEmpty('IRAC') // clears all inputs fields
                                }} 
                            />
                            {IRACLoansData.map(eirObject => (
                                <div key={1} 
                                    className={ createTab === 'A' ? AcntPolcyCss.cardContainerSideContainer : AcntPolcyCss.cardContainer}  
                                    onClick={() => {
                                        setsideTabType('IRAC'); 
                                        setupadteSelectedIRAC(eirObject._id);
                                        setCreateTab('A');
                                        fillTheDataInToInputs('IRAC', eirObject._id); 
                                        setCreateOrUpdate('U');
                                    }}>
                                    <div className={AcntPolcyCss.cardHeader}>
                                        <div className={AcntPolcyCss.CardTitle}>
                                            {eirObject.name}
                                        </div>
                                        <div>
                                            <CardEditIcon className={AcntPolcyCss.editIconSize} />
                                        </div>
                                    </div>
                                    <div className={AcntPolcyCss.cardDesc}>
                                        <img src={demoUserImg} alt="" style={{ height:'20px', width:'20px', borderRadius : '50%' }} />
                                        &nbsp;
                                        <span>
                                            Created by <span className={AcntPolcyCss.createdByName}>Adrienne Vossler</span>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                } 
            </div>
            {/* Create container */}
            {
                createTab == 'A' ? (
                    <>
                    {
                        sideTabType == 'EIR' ? (
                            <div className={AcntPolcyCss.CreateContainer}>
                                <div className={AcntPolcyCss.sideModelHeader}>
                                    <div className={AcntPolcyCss.sideModelTitle}>
                                    {createOrUpdate == 'C' ? 'Create New Scenario' : 'Update Scenario'}
                                    </div>
                                        <div onClick={() => setCreateTab('I')} style={{ cursor : 'pointer', paddingRight:'20px' }}>
                                            <CloseSideModel className={sidemenucss.sideModelCloseIcon} />
                                        </div>
                                </div>

                                <div className={AcntPolcyCss.InptContainer}>
                                    <span className={AcntPolcyCss.Inptlabel}>Scenario Name</span>
                                    <input className={AcntPolcyCss.inpt} type="text" 
                                        value={EirScenarioName || ''}
                                        onChange={(event) => {setEirScenarioName(event.target.value)}}
                                        placeholder="Enter name" 
                                    />
                                </div>

                                <div className={AcntPolcyCss.methodTypeContainer}>
                                    <div className={AcntPolcyCss.methodType}>
                                        Calculation Type
                                    </div>
                                    <div className={AcntPolcyCss.methodInptContainer}>

                                    <label className={AcntPolcyCss.LabelContant} style={{ marginRight: '20px' }} onClick={() => {setEirCalculateType('straightLine')}}>
                                        {EirCalculateType === 'straightLine' ? <ActiveRadioBtn className={AcntPolcyCss.custuRadioBtn} /> : <InactiveRadioBtn className={AcntPolcyCss.custuRadioBtn} />}
                                        Straight Line
                                    </label>

                                    <label className={AcntPolcyCss.LabelContant} style={{ marginRight: '20px' }} onClick={() => {setEirCalculateType('proportionateInterest')}}>
                                        {EirCalculateType === 'proportionateInterest' ? <ActiveRadioBtn className={AcntPolcyCss.custuRadioBtn} /> : <InactiveRadioBtn className={AcntPolcyCss.custuRadioBtn} />}
                                        Proportionate Interest
                                    </label>

                                   <label className={AcntPolcyCss.LabelContant} onClick={() => {setEirCalculateType('EIR')}}>
                                        {EirCalculateType === 'EIR' ? <ActiveRadioBtn className={AcntPolcyCss.custuRadioBtn} /> : <InactiveRadioBtn className={AcntPolcyCss.custuRadioBtn} />}
                                        EIR
                                    </label>

                                    </div>
                                </div>

                                <div className={AcntPolcyCss.EirInfoMainContainer}>
                                    <div className={AcntPolcyCss.EirInfoContainer}>
                                        <div className={AcntPolcyCss.infoContainerEir}>
                                            <div className={AcntPolcyCss.IconContainer}>
                                                <QuestionMark />
                                            </div>
                                            <div className={AcntPolcyCss.infoEirText}>
                                                {EirCalculateType === 'straightLine' && 'Interest income is recognized evenly over the loan tenure, spreading total interest equally across all periods.'}
                                                {EirCalculateType === 'proportionateInterest' && 'Interest income is recognized based on the outstanding loan principal — higher in earlier periods, lower as the balance reduces.'}
                                                {EirCalculateType === 'EIR' && 'Interest income is recognized using a constant rate that discounts expected future cash flows to the loan’s carrying amount, reflecting the true yield over its life.'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={AcntPolcyCss.methodTypeContainer}>
                                    <div className={AcntPolcyCss.methodType}>
                                        Compute EIR
                                    </div>
                                    <div className={AcntPolcyCss.ComputEirInputContainer}>

                                        <label className={AcntPolcyCss.LabelContant} style={{ marginRight: '20px' }} onClick={() => {setEirCompute('grossOfECL')}}>
                                            {EirCompute === 'grossOfECL' ? <ActiveRadioBtn className={AcntPolcyCss.custuRadioBtn} /> : <InactiveRadioBtn className={AcntPolcyCss.custuRadioBtn} />}
                                            Gross of ECL
                                        </label>

                                        <label className={AcntPolcyCss.LabelContant} onClick={() => {setEirCompute('netOfECL')}}>
                                            {EirCompute === 'netOfECL' ? <ActiveRadioBtn className={AcntPolcyCss.custuRadioBtn} /> : <InactiveRadioBtn className={AcntPolcyCss.custuRadioBtn} />}
                                            Net of ECL
                                        </label>

                                    </div>
                                </div>

                                <div className={AcntPolcyCss.createCanelBtnContainer}>

                                    <div>
                                        <button className={`${AcntPolcyCss.cancelStagingBtn}`} type="button" onClick={() => {setCreateTab('I')}}>
                                            Cancel
                                        </button>
                                        {createOrUpdate === 'U' ? 
                                            <button className={`${AcntPolcyCss.delBtn}`} type="button" 
                                                onClick={() => sendDataToEirApi('D')}
                                            >
                                            Delete EIR
                                            </button>
                                        :
                                            null
                                        }
                                    </div>

                                    <button 
                                        onClick={() => {sendDataToEirApi(createOrUpdate === 'C' ? 'C' : 'U')}}
                                        className={`${AcntPolcyCss.createStagingBtn}`} 
                                        type="button" 
                                    >
                                        {createOrUpdate === 'C' ? 'Create' : 'Update'}
                                    </button>
                                    
                                </div>
                            </div>
                        ) 
                        : 
                        null
                    }
                    {/* Create Container */}
                    {sideTabType == 'IRAC' ? 
                        (
                            <div className={AcntPolcyCss.CreateContainer}>
                                <div className={AcntPolcyCss.sideModelHeader}>
                                    <div className={AcntPolcyCss.sideModelTitle}>
                                        {createOrUpdate === 'C' ? 'Create New Scenario' : 'Update Scenario IRAC'}
                                    </div>
                                    <div onClick={() => setCreateTab('I')} style={{ cursor : 'pointer', paddingRight:'20px' }}>
                                        <CloseSideModel className={sidemenucss.sideModelCloseIcon} />
                                    </div>
                                </div>

                                <div className={AcntPolcyCss.InptContainer}>
                                    <span className={AcntPolcyCss.Inptlabel}>Scenario Name</span>
                                    <input className={AcntPolcyCss.inpt} type="text" 
                                        value={IRACName || ''}
                                        onChange={(e) => {setIRACName(e.target.value);}}
                                        placeholder="Enter name"
                                    />
                                </div>

                                <div className={AcntPolcyCss.InptContainer}>
                                    <div className={AcntPolcyCss.tableContainer}>
                                        <table className={AcntPolcyCss.customTable}>
                                            <thead>
                                            <tr>  
                                                <th key={1}>field asset category</th>
                                                <th key={2}>provision category</th>
                                                <th key={3}>range</th>
                                                <th key={4}>provision percentage</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr key={1}>
                                                    <td key={1}>Standard</td>
                                                    <td key={1}>Upto 90 days</td>
                                                    <td key={1}>4% to 8%</td>
                                                    <td key={1}>
                                                        <input 
                                                            className={AcntPolcyCss.iracInpt} 
                                                            type="text" 
                                                            placeholder='Enter percentage...' 
                                                            value={IRACStandard || ''}
                                                            onChange={(e) => {setIRACStandard(e.target.value)}}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr key={2}>
                                                    <td key={1}>Sub-standard</td>
                                                    <td key={1}>Upto 90 days</td>
                                                    <td key={1}>4% to 8%</td>
                                                    <td key={1}>
                                                        <input 
                                                            className={AcntPolcyCss.iracInpt} 
                                                            type="text" 
                                                            placeholder='Enter percentage...' 
                                                            value={IRACSubStandard || ''}
                                                            onChange={(e) => {setIRACIRACSubStandard(e.target.value)}}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr key={3}>
                                                    <td key={1}>Doubtful Assets 1</td>
                                                    <td key={1}>Upto 90 days</td>
                                                    <td key={1}>4% to 8%</td>
                                                    <td key={1}>
                                                        <input 
                                                            className={AcntPolcyCss.iracInpt} 
                                                            type="text" 
                                                            placeholder='Enter percentage...' 
                                                            value={IRACSDoubtfulAssets1 || ''}
                                                            onChange={(e) => {setIRACSDoubtfulAssets1(e.target.value)}}    
                                                        />
                                                    </td>
                                                </tr>
                                                <tr key={4}>
                                                    <td key={1}>Doubtful Assets 2</td>
                                                    <td key={1}>Upto 90 days</td>
                                                    <td key={1}>4% to 8%</td>
                                                    <td key={1}>
                                                        <input 
                                                            className={AcntPolcyCss.iracInpt} 
                                                            type="text" 
                                                            placeholder='Enter percentage...' 
                                                            value={IRACSDoubtfulAssets2 || ''}
                                                            onChange={(e) => {setIRACSDoubtfulAssets2(e.target.value)}}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className={AcntPolcyCss.createCanelBtnContainer}>
                                    <div>
                                        <button className={`${AcntPolcyCss.cancelStagingBtn}`} type="button" onClick={() => {setCreateTab('I')}}>
                                            Cancel
                                        </button>
                                        {createOrUpdate === 'U' ? 
                                            <button className={`${AcntPolcyCss.delBtn}`} type="button" 
                                                // onClick={() => sendDataToIRACApi('D')}
                                                onClick={()=> setDisplayModal(true)}

                                            >
                                                Delete IRAC
                                            </button>
                                        :
                                            null
                                        }
                                    </div>

                                    <button 
                                        onClick={() => {sendDataToIRACApi(createOrUpdate === 'C' ? 'C' : 'U')}}
                                        className={`${AcntPolcyCss.createStagingBtn}`} 
                                        type="button" 
                                    >
                                        {createOrUpdate === 'C' ? 'Create' : 'Edit'}
                                    </button>
                                    
                                </div>
                            </div>
                        )
                        :
                        null
                    }
                    </>
                ) : null
            }
            {displayModal && (
                 <Modal
                  headerActions={
                    <CloseIcon
                      onClick={() => {
                        handleClose();
                        setDisplayModal(false);
                      }}
                      className="clickable"
                    />
                  }
                  headerBottomLine={false}
                  onClose={() => console.log("Modal Closed")}
                >
                  <span className={`${modalcss.modalDeleteBodyHead}  mb-1`}>
                    {/* Do you want to <span className="fw700">delete</span> the
                    company? */}
                    Are you sure you want to Delete?
                  </span>
                  
                  <span
                    className={`${modalcss.modalDeleteBodycnt}`}
                    style={{ "margin-bottom": "35px ","marginTop": "10px","padding":"0px 45px" }}
                  > 
                    {/* Once deleted, you cannot restore the company */}
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.Nam enim  posuere. Aliquam.
                  </span>

                  <span
                    className={`${modalcss.modalDeleteBodycnt} ${modalcss.modalDeleteBodyBtns}`}
                  >
                    <Button
                      btnColor={buttoncss.dangerDeleteModelBtn}
                      label="Yes, Delete"
                    //   icon={<DeleteIcon width={20} height={20} />}
                      onClick={() => {
                        // deleteCompany();
                        sendDataToIRACApi('D'); 
                        handleClose();
                      }}
                    />
                    <Button
                      btnColor={buttoncss.deleteModelBtn_secondary_del}
                      label="No, Don't"
                      onClick={() => {
                        handleClose();
                        setDisplayModal(false);
                      }}
                    />
                  </span>
                </Modal>
)}

        </div>

    )

}